import {
  formatExchangeRate,
  formatMoney,
  type LocaleType,
} from '@landsbankinn/l16n';
import {
  formatAccountId,
  formatCreditCard,
  formatKennitala,
} from '@landsbankinn/ui-format';
import {
  type Account,
  type ScopeData,
  ScopeDataFormat,
  ScopeDataType,
} from '../../state/server';

export function formatData(data: ScopeData, locale: LocaleType) {
  switch (data.format) {
    case 'account': {
      return formatAccountId(data.value) ?? data.value;
    }
    case 'creditCard': {
      return formatCreditCard(data.value);
    }
    case 'kennitala': {
      return formatKennitala(data.value);
    }
    case 'money': {
      return formatMoney(locale, data.value, data.label ?? 'ISK', true);
    }
    case 'exchangeRate': {
      return formatExchangeRate(locale, data.value, data.label ?? 'ISK', true);
    }
    // case "number":
    default:
      return data.value;
  }
}

export function getAvailableAccounts(
  data: ScopeData,
  accounts?: Record<string, Account>,
) {
  const availableAccounts: Account[] = [];
  if (
    data.type === ScopeDataType.StringArray &&
    data.format === ScopeDataFormat.Account &&
    accounts
  ) {
    const v = data.value as string[];

    v.forEach((v) => {
      if (accounts[v]) {
        availableAccounts.push(accounts[v]);
      }
    });
  }
  return availableAccounts;
}

export function toggleSelected(value: string, selected: string[]) {
  if (selected.includes(value)) {
    return selected.filter((item) => item !== value);
  } else {
    return [...selected, value];
  }
}

export function groupBy(arr: any[], property: string) {
  return arr.reduce(function (prev, curr) {
    if (!prev[curr[property]]) {
      prev[curr[property]] = [];
    }
    prev[curr[property]].push(curr);
    return prev;
  }, {});
}

export function getLocalizedString(
  index: string,
  localization?: Record<string, string>,
) {
  return localization && localization[index] && localization[index].length > 0
    ? localization[index]
    : undefined;
}
